function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import NewBuilder from './NewBuilder';
import { sanitizeBuilderTree } from './NewBuilder/utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BuilderErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(BuilderErrorBoundary, _React$Component);
  var _super = _createSuper(BuilderErrorBoundary);
  function BuilderErrorBoundary(props) {
    var _this;
    _classCallCheck(this, BuilderErrorBoundary);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      localStorage.removeItem('custom_builder_draft_design');
      localStorage.removeItem('custom_builder_draft_html');
      window.location.reload();
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(BuilderErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      console.error('Custom Builder failed to render:', error);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/_jsx("div", {
          style: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: "'DM Sans', sans-serif",
            background: '#f4f5f7',
            color: '#1e293b'
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              maxWidth: 420,
              textAlign: 'center'
            },
            children: [/*#__PURE__*/_jsx("h2", {
              style: {
                margin: '0 0 12px 0'
              },
              children: "Builder could not load"
            }), /*#__PURE__*/_jsx("p", {
              style: {
                margin: '0 0 20px 0',
                color: '#64748b',
                lineHeight: 1.5
              },
              children: "Saved draft data may be corrupted. Reset the builder to start fresh."
            }), /*#__PURE__*/_jsx("button", {
              type: "button",
              onClick: this.handleReset,
              style: {
                background: '#101828',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '10px 20px',
                fontWeight: 600,
                cursor: 'pointer'
              },
              children: "Reset Builder"
            })]
          })
        });
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
  return BuilderErrorBoundary;
}(React.Component);
function loadSavedTree() {
  try {
    var savedData = localStorage.getItem('custom_builder_draft_design');
    if (!savedData) return null;
    var parsed = JSON.parse(savedData);
    if (!(parsed !== null && parsed !== void 0 && parsed.tree)) return null;
    var sanitized = sanitizeBuilderTree(parsed.tree);
    return sanitized.length ? sanitized : null;
  } catch (e) {
    console.error('Failed to parse draft tree:', e);
    return null;
  }
}
export default function NewBuilderStandalone() {
  var handleSave = function handleSave(design, html) {
    localStorage.setItem('custom_builder_draft_design', JSON.stringify(design));
    localStorage.setItem('custom_builder_draft_html', html);
  };
  var savedTree = loadSavedTree();
  return /*#__PURE__*/_jsx(BuilderErrorBoundary, {
    children: /*#__PURE__*/_jsx(NewBuilder, {
      initialTree: savedTree,
      onSave: handleSave,
      height: "100vh",
      standalone: true
    })
  });
}